import Axios from 'axios'
import {AppSettings} from "../settings";
import {StorageService} from "./storage";

const axios = Axios.create({
    responseType: "json",
    headers: {
        'Content-Type': 'application/json',
    }
});

axios.interceptors.request.use(async (config) => {
        const token = StorageService.getItem(AppSettings.ticketName);
        const prefix = config.target ? config.target + '_' : '';

        if (token) {
            config.url = !config.url.includes('?')
                ? `${config.url}?${prefix}ticket=${token}`
                : `${config.url}&${prefix}ticket=${token}`
        }

        return config;
    },
    (error) => Promise.reject(error)
);

export default axios;
